import { render } from "./IlionModal.vue?vue&type=template&id=16ea5c32&scoped=true"
import script from "./IlionModal.vue?vue&type=script&lang=js"
export * from "./IlionModal.vue?vue&type=script&lang=js"

import "./IlionModal.vue?vue&type=style&index=0&id=16ea5c32&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16ea5c32"]])

export default __exports__